import { notification } from 'antd';
export function antNotification(t, msg) {
  var mess = {
    success: '成功',
    info: '信息',
    warning: '警告',
    error: '错误'
  };
  notification.open({
    type: t,
    message: mess[t],
    description: msg,
    top: 48,
    maxCount: 2
  });
}